<div class="main-tab__title">
  <div class="title">
    <div>{{ title }}</div>
  </div>
  <ng-content></ng-content>
  <div *ngIf="optionHeader" class="three-dots" (click)="ellipsisClick($event)">
    <div class="icon" [inlineSVG]="'assets/three_dots.svg'"></div>
  </div>
</div>